module.exports = __webpack_public_path__ + "static/media/card_sculpins.04dc28b7.jpg";